import { useNavigate } from 'react-router-dom';

const GUARANTEE_POINTS = [
  {
    icon: 'ri-tools-line',
    title: 'We Come Back — No Questions Asked',
    desc: 'If anything shifts, lifts, or looks off within 30 days of completion, we return and fix it. Period.',
  },
  {
    icon: 'ri-phone-line',
    title: 'Direct Line to Your Crew',
    desc: 'You get direct contact with the team that did your job — not a call center, not a stranger.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Zero Extra Cost',
    desc: 'Follow-up visits within the guarantee window are completely free. Your investment is protected.',
  },
];

export default function GuaranteeSection() {
  const navigate = useNavigate();

  return (
    <section className="bg-[#1c1a17] py-24 px-4 md:px-8 relative overflow-hidden">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full"
          style={{
            backgroundImage:
              'repeating-linear-gradient(45deg, #c9a55a 0, #c9a55a 1px, transparent 0, transparent 50%)',
            backgroundSize: '20px 20px',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left — Badge + Headline */}
          <div className="flex flex-col items-start">
            {/* Guarantee Badge */}
            <div className="relative mb-10">
              <div className="w-44 h-44 rounded-full border-4 border-[#c9a55a] flex flex-col items-center justify-center text-center p-4 relative">
                <div className="absolute inset-2 rounded-full border border-[#c9a55a]/30" />
                <span className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.2em] leading-tight">
                  Our
                </span>
                <span className="text-white text-4xl font-black leading-none mt-1">30</span>
                <span className="text-[#c9a55a] text-sm font-black uppercase tracking-widest leading-tight">
                  Day
                </span>
                <span className="text-white text-xs font-bold uppercase tracking-[0.15em] mt-1 leading-tight">
                  Guarantee
                </span>
              </div>
              {/* Decorative star accents */}
              <div className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center">
                <i className="ri-star-fill text-[#c9a55a] text-sm" />
              </div>
              <div className="absolute -bottom-1 -left-2 w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-[#c9a55a] text-xs" />
              </div>
            </div>

            <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-4">
              Peace of Mind, Built In
            </p>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6">
              We Stand Behind <br />
              <span className="text-[#c9a55a]">Every Job We Do</span>
            </h2>
            <div className="w-16 h-1 bg-[#c9a55a] rounded-full mb-8" />
            <p className="text-[#a09890] text-base leading-relaxed max-w-md">
              Our work doesn&apos;t end when we pack up. For 30 days after project completion,
              we&apos;re still on the hook — and proud of it. That&apos;s how confident we are
              in the quality of our craftsmanship.
            </p>

            <button
              type="button"
              onClick={() => navigate('/contact')}
              className="mt-10 bg-[#c9a55a] hover:bg-[#b8943f] text-white font-bold text-sm px-8 py-4 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Get Your Free Estimate
            </button>
          </div>

          {/* Right — Points */}
          <div className="flex flex-col gap-6">
            {GUARANTEE_POINTS.map((point) => (
              <div
                key={point.title}
                className="flex items-start gap-5 border border-white/10 hover:border-[#c9a55a]/40 rounded-xl p-6 transition-all duration-300 cursor-default group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#c9a55a]/15 rounded-xl flex-shrink-0 group-hover:bg-[#c9a55a]/25 transition-colors duration-300">
                  <i className={`${point.icon} text-[#c9a55a] text-xl`} />
                </div>
                <div>
                  <h3 className="text-white font-bold text-base mb-2">{point.title}</h3>
                  <p className="text-[#a09890] text-sm leading-relaxed">{point.desc}</p>
                </div>
              </div>
            ))}

            {/* Bottom note */}
            <div className="flex items-center gap-3 mt-2 px-2">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-[#c9a55a] text-base" />
              </div>
              <p className="text-[#6b6560] text-xs leading-relaxed">
                Guarantee applies to all flooring installation, bathroom remodeling, and general construction services performed by VM Construction.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
